import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs: {
  q: string;
  a: string[];
}[] = [{
  q: 'Is this suitable for newly trained biodecoding practitioners?',
  a: ['Yes. If you have completed foundational training and are beginning your practice, the kit provides resources to help you prepare, guide, and close your sessions. It complements your training; it does not replace it or provide professional certification.']
}, {
  q: 'Does the kit include resources to use after intake?',
  a: ['Yes. Volume III includes 15 guided symbolic integration exercises, including reflective writing, dialogue with the body, visualisation, boundary exercises, and session-closing practices. It also includes examples of 5- and 15-minute integration sequences. The bonuses provide additional reflection and follow-up resources.', 'These are emotional exploration resources, not medical treatment protocols.']
}, {
  q: 'How do I receive the material?',
  a: ['Immediately after purchase, you will receive access to the complete digital PDF collection. You can download it and keep it for personal professional use.']
}, {
  q: 'Do I need to print everything?',
  a: ['No. The Kit was designed to work both as print-ready material and as a digital reference library on your tablet, computer, or phone.']
}, {
  q: 'Is the 7-day guarantee real?',
  a: ['Yes. You have 7 days from your purchase date to review the materials. If the Kit is not right for you, contact our support team within that period.']
}, {
  q: 'Can I share the files with other practitioners?',
  a: ['No. Your purchase includes a personal-use licence for one practitioner. The files may not be copied, shared, redistributed, resold, or uploaded without written permission from Lumen Akasha™.']
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-89" data-mp="n1stz2vzwgi1">
      <div className="mb-10 text-center" data-id="element-90" data-mp="2pmwtngtvtx49">
        <h2 className="flex justify-center text-2xl font-bold text-blue-900 md:text-4xl" data-id="element-91" data-mp="2pnya60to3btd">
          <span className="mr-3" data-id="element-92" data-mp="2kuluwhavohda">❓</span>FREQUENTLY ASKED QUESTIONS
        </h2>
      </div>
      <div className="space-y-4" data-id="element-93" data-mp="2fxdaea29c18v">
        {faqs.map((faq, index) => <div key={faq.q} className="overflow-hidden rounded-2xl border border-l-4 border-slate-200 border-l-blue-700 bg-white shadow-sm" data-id="element-94" data-mp="2ay91lkj8w5j2" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-stone-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400" data-id="element-95" data-mp="38kzfxnv1pfyd">
              <span className="pr-8 text-sm font-semibold text-blue-900 md:text-base" data-id="element-96" data-mp="1n86ezjy3nrru">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-amber-700 transition-transform duration-200 ease-out ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-97" data-mp="1j6ktxbbew76k" />
            </button>
            <AnimatePresence initial={false} data-id="element-98" data-mp="3us3g2ry018xv">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-99" data-mp="2qne60h6y2yh">
                  <div className="space-y-3 border-t border-slate-100 bg-white px-6 py-4 text-sm leading-relaxed text-slate-700 md:text-base" data-id="element-100" data-mp="hhcwdmt2kibu">
                    {faq.a.map(paragraph => <p key={paragraph} data-id="element-101" data-mp="qg82z000zufo">{paragraph}</p>)}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}